var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 62 192 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "full-color"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.914,124.429c-3.16,0 -5.996,-0.687 -8.508,-2.062c-2.512,-1.375 -4.487,-3.35 -5.925,-5.925c-1.438,-2.575 -2.157,-5.585 -2.157,-9.03c0,-3.444 0.719,-6.454 2.157,-9.029c1.438,-2.576 3.413,-4.551 5.925,-5.925c2.512,-1.375 5.348,-2.062 8.508,-2.062c2.149,0 4.069,0.252 5.76,0.758c1.69,0.506 3.373,1.232 5.048,2.18c0.695,0.38 1.042,0.98 1.042,1.802c0,0.474 -0.173,0.892 -0.521,1.256c-0.348,0.363 -0.806,0.545 -1.375,0.545c-0.316,0 -0.6,-0.063 -0.853,-0.19c-1.39,-0.727 -2.749,-1.28 -4.076,-1.659c-1.327,-0.379 -2.86,-0.569 -4.598,-0.569c-2.718,0 -5.032,0.561 -6.944,1.683c-1.912,1.122 -3.35,2.655 -4.313,4.598c-0.964,1.943 -1.446,4.148 -1.446,6.612c0,2.465 0.482,4.669 1.446,6.613c0.963,1.943 2.401,3.476 4.313,4.597c1.912,1.122 4.226,1.683 6.944,1.683c1.738,0 3.271,-0.189 4.598,-0.569c1.327,-0.379 2.686,-0.932 4.076,-1.659c0.253,-0.126 0.537,-0.189 0.853,-0.189c0.569,0 1.027,0.174 1.375,0.521c0.348,0.348 0.521,0.774 0.521,1.28c0,0.822 -0.347,1.422 -1.042,1.801c-1.675,0.948 -3.358,1.675 -5.048,2.181c-1.691,0.505 -3.611,0.758 -5.76,0.758Z",
    style: {
      fill: "#005175",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.338,124.192c-0.601,0 -1.106,-0.205 -1.517,-0.616c-0.411,-0.411 -0.616,-0.917 -0.616,-1.517l0,-29.246c0,-0.6 0.205,-1.114 0.616,-1.54c0.411,-0.427 0.916,-0.64 1.517,-0.64c0.6,0 1.113,0.213 1.54,0.64c0.427,0.426 0.64,0.94 0.64,1.54l0,29.246c0,0.6 -0.213,1.106 -0.64,1.517c-0.427,0.411 -0.94,0.616 -1.54,0.616Z",
    style: {
      fill: "#005175",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.612,124.429c-3.255,0 -6.147,-0.719 -8.675,-2.157c-2.528,-1.438 -4.487,-3.444 -5.877,-6.02c-1.391,-2.575 -2.086,-5.506 -2.086,-8.792c0,-3.35 0.727,-6.32 2.181,-8.911c1.453,-2.592 3.436,-4.598 5.948,-6.02c2.512,-1.422 5.301,-2.133 8.366,-2.133c2.465,0 4.622,0.3 6.471,0.9c1.848,0.601 3.626,1.438 5.332,2.512c0.253,0.127 0.474,0.348 0.664,0.664c0.189,0.316 0.284,0.664 0.284,1.043c0,0.537 -0.182,0.995 -0.545,1.374c-0.363,0.38 -0.845,0.569 -1.446,0.569c-0.347,0 -0.679,-0.079 -0.995,-0.237c-1.485,-0.885 -2.971,-1.548 -4.456,-1.991c-1.485,-0.442 -3.097,-0.663 -4.835,-0.663c-2.401,0 -4.566,0.505 -6.493,1.517c-1.928,1.011 -3.437,2.488 -4.527,4.432c-1.09,1.943 -1.635,4.258 -1.635,6.944c0,2.465 0.513,4.669 1.54,6.612c1.027,1.943 2.512,3.476 4.456,4.598c1.943,1.122 4.242,1.683 6.896,1.683c2.971,0 5.736,-0.696 8.295,-2.086l0,-8.579l-7.821,0c-0.537,0 -0.995,-0.19 -1.374,-0.569c-0.379,-0.379 -0.569,-0.838 -0.569,-1.375c0,-0.537 0.19,-0.995 0.569,-1.374c0.379,-0.38 0.837,-0.569 1.374,-0.569l9.338,0c0.632,0 1.169,0.221 1.612,0.663c0.442,0.443 0.663,0.98 0.663,1.612l0,10.76c0,0.663 -0.165,1.256 -0.497,1.777c-0.332,0.522 -0.767,0.909 -1.304,1.162c-3.539,1.769 -7.157,2.654 -10.854,2.654Z",
    style: {
      fill: "#005175",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.363,124.429c-3.318,0 -6.226,-0.727 -8.722,-2.18c-2.497,-1.454 -4.424,-3.461 -5.783,-6.02c-1.359,-2.56 -2.07,-5.499 -2.133,-8.817c0.063,-3.318 0.774,-6.256 2.133,-8.816c1.359,-2.56 3.286,-4.566 5.783,-6.02c2.496,-1.454 5.404,-2.18 8.722,-2.18c3.318,0 6.217,0.726 8.697,2.18c2.481,1.454 4.409,3.468 5.783,6.044c1.375,2.575 2.094,5.506 2.157,8.792c-0.063,3.287 -0.782,6.218 -2.157,8.793c-1.374,2.575 -3.302,4.59 -5.783,6.044c-2.48,1.453 -5.379,2.18 -8.697,2.18Zm0,-4.029c2.528,0 4.724,-0.569 6.588,-1.706c1.865,-1.138 3.287,-2.686 4.266,-4.646c0.98,-1.959 1.47,-4.171 1.47,-6.636c0,-2.464 -0.49,-4.676 -1.47,-6.636c-0.979,-1.959 -2.401,-3.507 -4.266,-4.645c-1.864,-1.138 -4.06,-1.706 -6.588,-1.706c-2.56,0 -4.764,0.568 -6.613,1.706c-1.848,1.138 -3.262,2.686 -4.242,4.645c-0.98,1.96 -1.47,4.172 -1.47,6.636c0,2.465 0.49,4.677 1.47,6.636c0.98,1.96 2.394,3.508 4.242,4.646c1.849,1.137 4.053,1.706 6.613,1.706Z",
    style: {
      fill: "#005175",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gradient"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 67.117,
    width: 71.246,
    height: 57.767
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.811,70.993c-0.113,0.704 -2.474,10.076 12.477,30.105c14.952,20.029 28.387,17.11 32.309,10.576c2.677,-4.46 2.004,-9.42 9.469,-13.489c4.333,-2.362 12.808,-7.401 12.143,-7.65c-0.989,-0.371 -13.515,3.764 -18.077,5.427c-2.073,0.755 -6.945,3.403 -7.48,9.157c-1.023,11.002 -16.16,4.155 -24.295,-9.606c-3.996,-6.76 -6.836,-13.863 -8.2,-23.287c-0.751,-5.188 -1.617,-5.821 -4.647,-4.544c-1.097,0.462 -3.423,1.608 -3.699,3.311Z",
    style: {
      fill: "url(#_Linear2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.714,88.899c-0.555,0.798 -0.848,1.846 -0.655,3.062c0.336,2.113 2.16,4.978 6.785,9.675c0,0 -1.468,-0.862 -2.039,-0.295c-0.699,0.693 -1.165,2.372 -0.195,3.471c1.294,1.465 4.156,3.154 9.621,6.111c2.55,1.379 11.331,5.509 7.347,8.49c-1.885,1.41 -3.02,2.151 -3.02,2.151c0,0 10.827,9.225 25.994,-3.082c0,0 -12.847,3.857 -27.855,-12.889c-5.894,-6.577 -9.744,-12.441 -11.997,-15.996c-1.13,-1.782 -2.179,-3.299 -3.986,-0.698Z",
    style: {
      fill: "url(#_Linear3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.092,79.267c-0.243,4.431 0.429,8.395 3.392,14.389c6.178,12.495 15.719,14.059 15.719,14.059c0,0 -6.354,-4.406 -10.101,-14.059c-1.519,-3.912 -2.883,-9.11 -2.991,-14.798c-0.026,-1.387 0.481,-5.626 -3.159,-4.049c-2.13,0.923 -2.696,1.477 -2.86,4.458Z",
    style: {
      fill: "url(#_Linear4)"
    }
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(56.9588,-21.2428,21.2428,56.9588,10.8576,113.672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#028fff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#45a0ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59caf0",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(56.9588,-21.2428,21.2428,56.9588,10.8576,113.672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#028fff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#45a0ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59caf0",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(56.9588,-21.2428,21.2428,56.9588,10.8576,113.672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#028fff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#45a0ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59caf0",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.070a94e5028437ea3dbc50ad93ced97a.svg";
export { ForwardRef as ReactComponent };